export default "__VITE_ASSET__ZeTC7Kw7__"